import { INSTALLER_TOPOLOGY_API_URL } from './apis';
import { addResourceI18n, getI18nHasInstallerResource, getPathToMessages } from '@wix/app-installer/internal-use';
export const fetchTranslations = async (httpClient, i18n, topology, errors) => {
  try {
    const i18nHasInstallerResource = getI18nHasInstallerResource(i18n);
    if (!i18nHasInstallerResource) {
      let translationsStaticUrl = topology == null ? void 0 : topology.translations;
      if (!translationsStaticUrl) {
        const {
          data: {
            topology: {
              translations
            }
          }
        } = await httpClient.get(INSTALLER_TOPOLOGY_API_URL);
        translationsStaticUrl = translations;
      }
      const {
        data: messages
      } = await httpClient.get(getPathToMessages(translationsStaticUrl, i18n.language));
      addResourceI18n(i18n, messages);
    }
  } catch (e) {
    errors.push(e);
  }
};
//# sourceMappingURL=fetch-translations.js.map